import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { activateCode, checkActivationCode } from '../services/activationService';
import './ActivationCode.css';

// 将小时数转换为更合适的单位
const formatDuration = (hours) => {
  if (!hours) return '0小时';

  // 转换为天数
  const days = hours % 24 === 0 ? hours / 24 : 0;

  // 如果是365的倍数，转换为年
  if (days % 365 === 0 && days >= 365) {
    const yearCount = days / 365;
    return `${yearCount}年`;
  }

  // 如果是30或31的倍数，转换为月
  if ((days % 30 === 0 || days % 31 === 0) && days >= 30) {
    const monthCount = Math.round(days / 30.5);
    return `${monthCount}个月`;
  }

  // 如果是7的倍数，转换为周
  if (days % 7 === 0 && days >= 7) {
    const weekCount = days / 7;
    return `${weekCount}周`;
  }

  // 转换为天
  if (days !== 0) {
    return `${days}天`;
  }

  // 如果以上条件都不满足，则显示小时
  return `${hours}小时`;
};

const ActivationCode = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [memberInfo, setMemberInfo] = useState(null);

  const handleCheckCode = async () => {
    if (!code) {
      setError('请输入激活码');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const info = await checkActivationCode(code);
      setMemberInfo(info);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleActivate = async () => {
    if (!code) {
      setError('请输入激活码');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const result = await activateCode(code);
      setMemberInfo(result);
      // 激活成功后跳转
      navigate(`/member?code=${code}`);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const unitMap = {
    hour: '小时',
    day: '天',
    month: '月',
    year: '年'
  };

  return (
    <div className="activation-container">
      <div className="activation-header">
        <div className="header-left">
          <span className="back-button" onClick={handleBack}>
            ←
          </span>
          <span>激活会员</span>
        </div>
      </div>

      <div className="activation-content">
        <div className="input-group">
          <label className="input-label">激活码</label>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="请输入您的激活码"
            className="activation-input"
          />
          {error && <div className="error-message">{error}</div>}
        </div>

        {memberInfo && (
          <div className="member-info">
            <h3>会员信息</h3>
            {
              memberInfo.status === 'unused' ? (
                /* 未激活 */
                <>
                  <p>
                    激活状态：
                    <span>未激活</span>
                  </p>
                  <p>
                    有效期：
                    <span>{memberInfo.relative_duration}{unitMap[memberInfo.time_unit]}</span>
                  </p>
                </>
              ) : (
                /* 已激活 */
                <>
                  <p>
                    激活状态：
                    <span>已激活</span>
                  </p>
                  <p>
                    有效期至：
                    <span>{memberInfo.expires_at}</span>
                  </p>
                </>
              )
            }
          </div>
        )}

        <div className="button-group">
          <button
            onClick={handleCheckCode}
            disabled={loading}
            className="activation-button check-button"
          >
            {loading ? '检查中...' : '检查激活码'}
          </button>
          {
            memberInfo && memberInfo.status === 'unused' && (
              <button
                onClick={handleActivate}
                disabled={loading}
                className="activation-button activate-button"
              >
                {loading ? '激活中...' : '立即激活'}
              </button>
            )
          }
          {
            memberInfo && memberInfo.status === 'used' && (
              <button
                onClick={() => navigate(`/member?code=${code}`)}
                disabled={loading}
                className="activation-button activate-button"
              >
                进入会员页
              </button>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default ActivationCode;
